import { Container } from '@mui/material'
import { GetServerSideProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { parse } from 'next-useragent'
import React from 'react'
import { addApolloState, initializeApollo } from '../lib/apolloClient'
// * WISHLIST PAGE MODULE
import { WishlistProductList } from '../src/components/Modules'
import Layout from '../src/constants/Layout'
import { AppContextWrapper } from '../src/context/appContext'
import { WishlistContextWrapper } from '../src/context/wishlistContext'
import { GET_PARENT_CATEGORIES } from '../src/operations/queries'
import { APP_SHOP_SETTINGS } from '../src/operations/queries/_appQueries'
import { defaultMetaTags } from '../src/utilityFunctions/metaUtils/defaultMetaTags'
import { useShopSettingsInit } from '../src/utilityFunctions/useShopSettingsInit'

function Wishlist({
  locale,
  locales,
  defaultLocale,
  _nextI18Next,
  shopSettingsData,
  categoriesData,
  ...props
}) {
  const { t, i18n } = useTranslation(['common'])
  const { initialI18nStore } = _nextI18Next
  const pageName = t('wishlist-page')
  useShopSettingsInit(shopSettingsData.data.findFirstShopSetting)
  const shopSettings = { ...shopSettingsData.data.findFirstShopSetting }

  // ===== USER AGENT ==== information about incoming user
  // We use this info to determine if its Safari (as it doesnt support webp images)
  let ua
  if (props.uaString) {
    // ---- NO INFO HERE ------
    ua = parse(props.uaString)
  } else {
    ua = parse(window.navigator.userAgent)
  }

  return (
    <>
      {defaultMetaTags({
        shopSettingsData,
        locale,
        locales,
        defaultLocale,
        initialI18nStore,
        pageName,
      })}
      <AppContextWrapper locale={locale} shopSettings={shopSettings}>
        <WishlistContextWrapper data={{}} locale={locale}>
          <Layout categoriesData={categoriesData} locale={locale}>
            <Container maxWidth="xl">
              <WishlistProductList />
            </Container>
          </Layout>
        </WishlistContextWrapper>
      </AppContextWrapper>
    </>
  )
}

//* ============ PROPS

export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
  locales,
  defaultLocale,
  req,
}) => {
  const apolloClient = initializeApollo()
  const SHOP_ID = JSON.parse(process.env.NEXT_PUBLIC_SHOP_ID)

  const shopSettingsData = await apolloClient.query({
    query: APP_SHOP_SETTINGS,
    variables: {
      SHOP_ID,
      isHomepage: false,
      isProductPage: false,
    },
  })

  // --- Category menu component
  const categoriesData = await apolloClient.query({
    query: GET_PARENT_CATEGORIES,
    variables: {
      language: locale,
    },
  })

  return addApolloState(apolloClient, {
    props: {
      uaString: req.headers['user-agent'],
      locale,
      locales,
      defaultLocale,
      categoriesData,
      ...(await serverSideTranslations(locale, ['common'])),
      shopSettingsData,
    },
  })
}

export default Wishlist
